import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { StyledModal, StyledModalHandle } from '@constants/Themed';
import { useState, useCallback } from 'react';
import { Platform, View, Text, Image } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import * as Animatable from 'react-native-animatable';
import { Title } from '@constants/Themed';
import moment from 'moment';
import styles from '@stylesheet';
import toTitleCase from '@hooks/toTitleCase';
import parseByDelimiter from '@utils/parseByDelimiter';
import { DataFolderType } from '@types/dataFolderTypes';
import GenerateSchemaForm from '@hooks/generateSchemaForm';
import apis from '@api/api';
import DataSetChart from '@components/dataTables/Charts/DataSetChart';
import { useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';

interface QuickAddProps {

}

export interface QuickAddHandle {
  openModal: (item) => void;
}

const QuickAddDataModal = forwardRef<QuickAddHandle, QuickAddProps>((props, ref) => {
  const [item, setItem] = useState<DataFolderType>();
  const quickAddRef = useRef<StyledModalHandle>(null);
  const queryClient = useQueryClient();
  const globalDate = useSelector((state:DefaultRootState) => state.UI.dateFormat);

  useImperativeHandle(ref, () => ({
    openModal: (item) => {
      quickAddRef.current?.openModal?.();
      setItem(item);
    }
  }));

  return (
    <StyledModal
      ref={quickAddRef}
      title={toTitleCase(parseByDelimiter(item?.dataTitle || ""))}
      caption=" "
      onModalWillHide={() => queryClient.fetchQuery({ queryKey: ['dataFolders'] })}
      customContent={item && (
        <View style={{ padding: 30, backgroundColor: "transparent", maxHeight: 800, flex: 1, gap: 20, }}>
          <View style={[styles.centerEverything, { flex: 1, backgroundColor: "transparent", maxHeight: 50, marginVertical: -20, flexDirection: 'row', gap: 20, justifyContent: 'center' }]}>
            <AntDesign name="setting" size={25} color="white" style={{ textAlign: 'center', verticalAlign: 'middle', justifyContent: 'center' }} />
            <Title style={{ color: "white" }}>{toTitleCase(parseByDelimiter(item?.dataTitle))}</Title>
          </View>
          <View style={[styles.centerEverything, { minHeight: 180, backgroundColor: "transparent", flex: 1, flexDirection: "row", overflow: "visible" }]}>
            <Image source={{ uri: item.owner?.profile_information.avatar.img }} style={[styles.centerEverything, { resizeMode: 'contain', borderRadius: 20, flex: 1, height: 80, width: 80, }]} />
            <View style={{ flex: 3, padding: 10, backgroundColor: 'transparent' }}>
              <Text style={{ color: "white" }}>Owner</Text>
              <Text style={{ fontWeight: '600', fontSize: 16, color: "white" }}>{toTitleCase(item.owner?.profile_information.name)} {toTitleCase(item.owner?.profile_information.surname)}</Text>
              <Text style={{ color: "white" }}>Created: {moment(item.createdAt).format(globalDate)}</Text>
            </View>
          </View>
        </View >
      )}>
      <View style={{ flex: 1, paddingVertical: 50, minHeight: "80%", maxHeight: 700 }}>
        <GenerateSchemaForm scrollEnabled Progress schema={item?.dataSchema} hasTitle submitFunction={apis.addDataItem} noBackground
        extraFunction={()=> {
          queryClient.invalidateQueries({ queryKey: ['dataFolders'] });
        }}
         internalButton={false} other={item?._id} resetOnSubmit />
      </View>
    </StyledModal>
  );
});

export default QuickAddDataModal;